import {React} from '../utils/thirdpartyComponents';
const FullLoader = () => {
  return (
    <div className="cw-loader-overlay align-items-center justify-content-center">
        <div className="cw-loader"></div>
    </div>
  );
};

export default FullLoader;
